// src/fleet-stats/utils/flattenResults.js

export function normalizeClientName(client, siteName) {
    if (
        (client || "").toLowerCase() === "beewatec" &&
        (siteName || "").toLowerCase() === "hungary"
    ) {
        return "avon";
    }
    return client || "";
}

/**
 * Flatten the raw robot_stats.json into a flat array of daily rows.
 * Each row: { client, siteId, siteName, robotId, robotName, date,
 *             distance_m, moving_time_s, uptime_s }
 */
export function flattenResults(data) {
    const rows = [];
    if (!data || !data.sites) return rows;

    for (const [siteId, site] of Object.entries(data.sites)) {
        if (site.error) continue;

        for (const r of site.robots || []) {
            if (r.error) continue;

            for (const d of r.daily || []) {
                const rawClient = site.client || "";
                const rawSiteName = site.site_name || siteId;

                rows.push({
                    client: normalizeClientName(rawClient, rawSiteName),
                    siteId,
                    siteName: rawSiteName,
                    robotId: r.robot_id,
                    robotName: r.name || r.robot_id,
                    date: d.date,
                    distance_m: d.distance_m || 0,
                    moving_time_s: d.moving_time_s || 0,
                    uptime_s: d.uptime_s || 0,
                });
            }
        }
    }

    return rows;
}